module.exports = __webpack_public_path__ + "img/photo_example2.138b57b0.png";